import { Calendar, User, Users } from 'lucide-react';

import {
  Accordion,
  AccordionTab,
  Checkbox,
  type CheckboxChangeEvent,
} from '../compat-controls';

export interface SettingsItem {
  id: string | number;
  title: string;
  icon?: string;
  content: React.ReactNode;
  showCheckbox?: boolean;
  checked?: boolean;
  onCheckChange?: (checked: boolean) => void;
}

interface SettingsListProps {
  items: SettingsItem[];
  multiple?: boolean;
}

export function SettingsList({ items, multiple = false }: SettingsListProps) {
  const renderIcon = (icon?: string) => {
    if (!icon) return null;
    if (icon.includes('pi-user')) return <User className="size-4" />;
    if (icon.includes('pi-users')) return <Users className="size-4" />;
    if (icon.includes('pi-calendar')) return <Calendar className="size-4" />;
    return null;
  };
  return (
    <Accordion multiple={multiple} className="w-full">
      {items.map((item) => (
        <AccordionTab
          key={item.id}
          header={
            <span className="flex w-full items-center justify-between">
              <span className="flex items-center gap-2">
                {renderIcon(item.icon)}
                <span className="font-medium">{item.title}</span>
              </span>

              {item.showCheckbox && (
                <Checkbox
                  inputId={`chk-${item.id}`}
                  checked={!!item.checked}
                  onChange={(e: CheckboxChangeEvent) =>
                    item.onCheckChange?.(e.checked ?? false)
                  }
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                />
              )}
            </span>
          }
        >
          <div className="p-2">{item.content}</div>
        </AccordionTab>
      ))}
    </Accordion>
  );
}
